var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noPermissions"},[_c('svg-icon',{style:({ fontSize: _vm.size }),attrs:{"icon-class":"nopermissions"}}),_vm._v(" "),_c('h3',{staticClass:"ant-result-subtitle"},[_vm._v(_vm._s(_vm.title)),_vm._t("link")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../cache/node/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14f0ede4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../cache/node/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoPermissions/index.vue
// module id = null
// module chunks = 